import { Store, Module, ActionContext } from "vuex";
import ListModule from "./list-module";
import ListState from "./list-state";
import Ajax from "../../lib/ajax";
import PageResult from "@/store/entities/page-result";

interface ReturnOrderState extends ListState<any> {
    lineTotalCount: number,
    lineCurrentPage: number,
    linePageSize: number,
    lineList: Array<any>,
    lineLoading: boolean,

    receiptTotalCount: number,
    receiptCurrentPage: number,
    receiptPageSize: number,
    receiptList: Array<any>,
    receiptLoading: boolean,
}
class ReturnOrderModule extends ListModule<ReturnOrderState, any, any> {
  state = {
    totalCount: 0,
    currentPage: 1,
    pageSize: 10,
    list: new Array<any>(),
    loading: false,

    lineTotalCount: 0,
    lineCurrentPage: 1,
    linePageSize: 10,
    lineList: new Array<any>(),
    lineLoading: false,

    receiptTotalCount: 0,
    receiptCurrentPage: 1,
    receiptPageSize: 10,
    receiptList: new Array<any>(),
    receiptLoading: false,
  };
  actions = {
    async getStatusForSelect(context: ActionContext<ReturnOrderState, any>, payload: any) {
      const {data:{result} } = await Ajax.get('/api/services/app/ReturnOrder/GetStatusForSelect',{ params: payload.data });
      return result.items;
    },
    async get(context: ActionContext<ReturnOrderState, any>, payload: any) {
      let reponse=await Ajax.get(`/api/services/app/ReturnOrder/${payload.data.id}` );
      return reponse.data.result ;
  },
    async getAll(
      context: ActionContext<ReturnOrderState, any>,
      payload: any
    ) {
      context.state.loading = true;
      const {
        data: { result },
      } = await Ajax.get("/api/services/app/returnOrder/GetAll", {
        params: payload.data,
      });
      context.state.loading = false;
      const page = result as PageResult<any>;
      context.state.totalCount = page.totalCount;
      context.state.list = page.items;
      console.log('list', page.items);
    },
    async getAllLines(
      context: ActionContext<ReturnOrderState, any>,
      payload: any
    ) {
      context.state.lineLoading = true;
      const {
        data: { result },
      } = await Ajax.get(`/api/services/app/returnOrder/${payload.data.id}/getAll-lines`, {
        params: payload.data,
      });
      context.state.lineLoading = false;
      const page = result as PageResult<any>;
      context.state.lineTotalCount = page.totalCount;
      context.state.lineList = page.items;
    },
    async getAllReceipts(
      context: ActionContext<ReturnOrderState, any>,
      payload: any
    ) {
      context.state.receiptLoading = true;
      const {
        data: { result },
      } = await Ajax.get(`/api/services/app/returnOrder/${payload.data.id}/getAll-receipts`, {
        params: payload.data,
      });
      context.state.receiptLoading = false;
      const page = result as PageResult<any>;
      context.state.receiptTotalCount = page.totalCount;
      context.state.receiptList = page.items;
    },
  };

  mutations = {
    setCurrentPage(state: ReturnOrderState, page: number) {
      state.currentPage = page;
    },
    setPageSize(state: ReturnOrderState, pagesize: number) {
      state.pageSize = pagesize;
    },
    setLineCurrentPage(state: ReturnOrderState, page: number) {
      state.lineCurrentPage = page;
    },
    setLinePageSize(state: ReturnOrderState, pagesize: number) {
      state.linePageSize = pagesize;
    },
    setReceiptCurrentPage(state: ReturnOrderState, page: number) {
      state.receiptCurrentPage = page;
    },
    setReceiptPageSize(state: ReturnOrderState, pagesize: number) {
      state.receiptPageSize = pagesize;
    },
  };
}
const returnOrderModule = new ReturnOrderModule();
export default returnOrderModule;
